import script from "./points-for-badge-received-dm.vue?vue&type=script&setup=true&lang=js"
export * from "./points-for-badge-received-dm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__